import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import IntlMessage from '../../../../../helpers/intlMessage';

function Auditoria ({ lista }) {
  const headerListItens = [
    <IntlMessage id="general.materialArchiving.user" />,
    <IntlMessage id="general.materialArchiving.requestDate" />,
    <IntlMessage id="general.materialArchiving.type" />,
    <IntlMessage id="general.materialArchiving.identification" />,
    <IntlMessage id="general.materialArchiving.examNumber" />,
    <IntlMessage id="general.materialArchiving.operation" />
  ];

  return (
    <TableReport
      title={<IntlMessage id="general.materialArchiving.AUDITREPORTOFFILINGANDMATERIALREQUEST" />}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      headerList={headerListItens}
    >
      {lista.map((item, i) => (
        <tr key={i}>
          <td>{item.usuario}</td>
          <td>{item.dataPedido}</td>
          <td>{item.tipo}</td>
          <td>{item.identificacao}</td>
          <td>{item.nrExame}</td>
          <td>{item.operacao}</td>
        </tr>
      ))}
    </TableReport>
  );
}

Auditoria.propTypes = {
  lista: PropTypes.array.isRequired
};

Auditoria.defaultProps = {
  lista: []
};

export default Auditoria;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/components/Auditoria/index.js